import { TbordOneToneIcon } from 'components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';

export interface IUploadInfo {
  title: string;
  description: string | JSX.Element;
  icon: TbordOneToneIcon;
  fontSize?: string;
}

export const uploadTemplateInfo: IUploadInfo = {
  title: 'Sube la plantilla actualizada',
  description: (
    <>
      Sube la plantilla en formato <strong>.xlsx</strong> para continuar con la carga masiva. Haz clic en “Subir
      plantilla” o arrástralo aquí. También puedes omitir este paso y subirlo después desde el Cargue masivo.
    </>
  ),
  icon: 'document'
};

export const uploadTemplateInfoWithErrors = (errorTemplateURL: string): IUploadInfo => ({
  title: 'Sube la plantilla sin errores',
  description: (
    <div>
      <div style={{ margin: 0 }}>
        Sube nuevamente la plantilla una vez que resuelvas los errores. ¿No se descargó correctamente el archivo?
      </div>
      <a href={errorTemplateURL} style={{ textDecoration: 'underline' }}>
        Descargar plantilla con errores
      </a>
    </div>
  ),
  icon: 'document'
});

export const templateUploadedInfo = (success: number, total: number): IUploadInfo => ({
  title: 'Tu plantilla ha sido cargada',
  description: (
    <>
      Se subieron{' '}
      <strong>
        {success} de {total} productos correctamente.
      </strong>{' '}
      Ahora puedes volver al Cargue masivo para realizar otro cargue o ir al catálogo para revisar los productos subidos
    </>
  ),
  icon: 'checkCircle',
  fontSize: '14px'
});

export const templateWithErrorsInfo = (success: number, total: number): IUploadInfo => ({
  title: 'Revisa y confirma la información',
  description: (
    <>
      Se subieron{' '}
      <strong>
        {success} de {total} productos.
      </strong>{' '}
      Algunos productos no pudieron subirse por errores
    </>
  ),
  icon: 'alertTriangleWarning',
  fontSize: '14px'
});
